var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"form-control-plaintext"},[_c('i',{staticClass:"fa fa-fw fa-lg",class:{
    'fa-caret-up text-success': _vm.value && _vm.value > 0,
    'fa-caret-down text-danger': _vm.value && _vm.value < 0
  }}),_vm._v("\n  "+_vm._s(_vm.$number2text(_vm.value, 2))+"\n  "),(!_vm.$isNaN(_vm.value))?[_vm._v("%")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }